import { ContentfulMetafieldCollection } from '@jbhi-fi/apis/src/contentful/types';
import { ThumbnailImageProps } from '../../ThumbnailImage/ThumbnailImage';
import { CollectionThumbnail } from '../../CollectionThumbnail/CollectionThumbnail';
import React from 'react';

export abstract class MetafieldCollectionTransformer {
  static browseToHref = (browse: Exclude<ContentfulMetafieldCollection['browse'], undefined>[number]): string => {
    if (browse.parentHandle) return `/collections/${browse.parentHandle}/${browse.handle || browse.path}`;
    return `/collections/${browse.handle || browse.path}`;
  };

  static toNavChipsProps = (
    entry?: ContentfulMetafieldCollection
  ): Array<{ label: string; href: string }> | undefined => {
    return (
      entry?.browse
        ?.map(browse => ({
          label: browse.title || browse.name || '',
          href: this.browseToHref(browse),
        }))
        .filter(e => e.href && e.label) ?? []
    );
  };

  static toThumbnailImagesProps = (
    entry?: ContentfulMetafieldCollection,
    { isLoading }: { isLoading?: boolean } = {}
  ): Array<ThumbnailImageProps> | undefined => {
    return this.toNavChipsProps(entry)?.map(({ label, href }) => ({
      title: label,
      href,
      image: (
        <CollectionThumbnail isLoading={isLoading} handle={href.replace(/(.*\/)*/, '')} sizePx={{ xs: 100, md: 120 }} />
      ),
    }));
  };
}
